module.exports = __webpack_public_path__ + "static/img/gallery-g.f9b95bc0.png";